<div class="summary-wrapper">
    <ion-item class="summary-tab" button color="-ion-color-white" lines="none">
        <ion-label class="section-title" color="dark-teal">
            <div class="summary-header dark-teal-2">Application Summary</div>
        </ion-label>
    </ion-item>

    <ion-list class="summary-list" lines="none">
        <div class="title-row">
            <div class="title-row-image">
                <img class="program-image" [src]="application?.program?.image | img: application?.state:'md'" />
            </div>
            <div class="ion-text-center title-row-text" (click)="viewProgram(application?.program?.id)">
                {{ application?.program?.name }}
            </div>
        </div>
        <ion-item>
            <ion-label class="summary-row-title label-width ion-align-items-start">Specialty:</ion-label>
            <ion-text class="summary-row-title content-width ion-align-items-center">{{ application?.specialty }} </ion-text>
        </ion-item>
        <ion-item>
            <ion-label class="summary-row-title label-width ion-align-items-start">Type:</ion-label>
            <ion-text class="summary-row-title content-width ion-align-items-center">{{ application?.type }} </ion-text>
        </ion-item>
        <ion-item>
            <ion-label class="summary-row-title label-width ion-align-items-start">Location:</ion-label>
            <ion-text class="summary-row-title content-width ion-align-items-center"
                >{{ application?.location }}<br />
                {{ application?.city }}, {{ application?.state }}</ion-text
            >
        </ion-item>
        <ion-item>
            <ion-label class="summary-row-title label-width ion-align-items-start">Start Date: </ion-label>
            <ion-text class="summary-row-title content-width ion-align-items-center">
                {{ application?.startdate | date: 'longDate':'UTC' }}
            </ion-text>
        </ion-item>
        <ion-item>
            <ion-label class="summary-row-title label-width ion-align-items-start">End Date:</ion-label>
            <ion-text class="summary-row-title content-width ion-align-items-center">
                {{ application?.enddate | date: 'longDate':'UTC' }}
            </ion-text>
        </ion-item>
        <ion-item>
            <ion-label class="summary-row-title label-width ion-align-items-start">Program Total Cost:</ion-label>
            <ion-text class="summary-row-title content-width ion-align-items-center"> ${{ application?.price }} USD </ion-text>
        </ion-item>
        <ion-item class="background-teal-book-now">
            <ion-label class="summary-row-title label-width ion-align-items-start bold-text-lower ion-text-wrap">Amount Due at Booking:</ion-label>
            <ion-text class="summary-row-title content-width ion-align-items-center bold-text"> $899 USD </ion-text>
        </ion-item>
    </ion-list>
</div>
